export default __webpack_public_path__ + "static/media/selflove.5b1b5330.webp";